import { fetchPublicDailyDealsApi } from '../../util/api';

const ns = 'app/DiscountsLandingPage';

export const FETCH_DAILY_DEALS_REQUEST = `${ns}/FETCH_DAILY_DEALS_REQUEST`;
export const FETCH_DAILY_DEALS_SUCCESS = `${ns}/FETCH_DAILY_DEALS_SUCCESS`;
export const FETCH_DAILY_DEALS_ERROR = `${ns}/FETCH_DAILY_DEALS_ERROR`;

const getErrorMessage = error =>
  error?.message || error?.error || 'Unable to load Daily Deals. Please try again.';

// The API answers NOT_FOUND while the page is gated and the viewer is not a Daily Deals admin.
export const isAccessDeniedError = error => error?.error === 'NOT_FOUND';

const initialState = {
  deals: [],
  pagination: null,
  fetchInProgress: false,
  loadMoreInProgress: false,
  fetchError: null,
  accessDenied: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_DAILY_DEALS_REQUEST:
      return {
        ...state,
        fetchInProgress: action.payload.page <= 1,
        loadMoreInProgress: action.payload.page > 1,
        fetchError: null,
      };
    case FETCH_DAILY_DEALS_SUCCESS:
      return {
        ...state,
        fetchInProgress: false,
        loadMoreInProgress: false,
        deals:
          action.payload.page > 1
            ? [...state.deals, ...(action.payload.deals || [])]
            : action.payload.deals || [],
        pagination: action.payload.pagination || null,
        accessDenied: false,
      };
    case FETCH_DAILY_DEALS_ERROR:
      return {
        ...state,
        fetchInProgress: false,
        loadMoreInProgress: false,
        fetchError: action.payload,
        accessDenied: Boolean(action.meta?.accessDenied),
      };
    default:
      return state;
  }
}

export const fetchDailyDeals = params => async dispatch => {
  const requestParams = {
    page: params?.page || 1,
    perPage: params?.perPage || 12,
    ...(params?.keyword ? { keyword: params.keyword } : {}),
    ...(params?.category ? { category: params.category } : {}),
  };

  dispatch({ type: FETCH_DAILY_DEALS_REQUEST, payload: requestParams });

  try {
    const response = await fetchPublicDailyDealsApi(requestParams);
    const payload = {
      page: requestParams.page,
      deals: response?.data || [],
      pagination: response?.pagination || null,
    };

    dispatch({ type: FETCH_DAILY_DEALS_SUCCESS, payload });
    return payload;
  } catch (error) {
    const message = getErrorMessage(error);
    dispatch({
      type: FETCH_DAILY_DEALS_ERROR,
      payload: message,
      meta: { accessDenied: isAccessDeniedError(error) },
    });
    throw error;
  }
};

export const loadData = () => dispatch => dispatch(fetchDailyDeals({ page: 1, perPage: 12 }));
